import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { TextField } from '../../../material-ui/TextField';
import * as landing from '../../../../actions/landing';

export const AdditionalField = memo(({ required, defaultValue, className }) => {
    const dispatch = useDispatch();
    const { t: translate } = useTranslation();

    const handleChangeComment = React.useCallback((evt) => {
        dispatch(landing.editField('fuelComment', evt.target.value));
    }, []);

    return (
        <TextField
            label={translate('flightInfoPage.additionalFuelInfo')}
            placeholder={translate('flightInfoPage.additionalFuelInfo')}
            name="fuelComment"
            onBlur={handleChangeComment}
            key="fuelComment"
            fullWidth={true}
            defaultValue={defaultValue}
            multiline={true}
            className={className}
            InputLabelProps={{
                shrink: true,
            }}
            minRows={1}
            maxRows={3}
            required={required}
        />
    );
});
